import { Project } from 'data/projects';
import interceptor from './interceptor';

export const getAllByUser = (userid: string) => {
  const request = interceptor.apiWithAuth.get(
    '/project/get-all-by-user/' + userid
  );
  return request
    .then(response => response.data)
    .catch(error => {
      return Promise.reject(
        error.response ? error.response.data : 'An error occurred'
      );
    });
};

const getAllProjects = () => {
  const request = interceptor.apiWithAuth.get('/pitchdeckstatus/get-all/');
  return request
    .then(response => response.data)
    .catch(error => {
      return Promise.reject(
        error.response ? error.response.data : 'An error occurred'
      );
    });
};

export const addProject = (project: Project) => {
  return interceptor.apiWithAuth
    .post('/project/add-project', project)
    .then(response => {
      console.log(response.data);
      const projectId = response.data;
      return projectId;
    })
    .catch(error => {
      return Promise.reject(
        error.response ? error.response.data : 'An error occurred'
      );
    });
};

//create an editProject function
export const editProject = (updatedFields: Partial<Project>) => {
  const updatedProject = {
    ...updatedFields // Merge updatedFields with the original project object
  };

  return interceptor.apiWithAuth
    .put('/project/edit-project', updatedProject)
    .then(response => {
      console.log(response.data);
      return response.data;
    })
    .catch(error => {
      return Promise.reject(
        error.response ? error.response.data : 'An error occurred'
      );
    });
};

//delete a project function
export const deleteProject = (project: Project) => {
  return interceptor.apiWithAuth
    .delete('/project/delete-project', { data: project })
    .then(response => {
      const projectId = response.data;
      return projectId;
    })
    .catch(error => {
      return Promise.reject(
        error.response ? error.response.data : 'An error occurred'
      );
    });
};
const getProjectByID = (projectId: string) => {
  const request = interceptor.apiWithoutAuth.get(
    '/project/get-project-by-id/' + projectId
  );
  return request
    .then(response => {
      if (response.data.dateCreated) {
        response.data.dateCreated = new Date(
          response.data.dateCreated
        ).toISOString();
      }
      if (response.data.dateModified) {
        response.data.dateModified = new Date(
          response.data.dateModified
        ).toISOString();
      }
      if (response.data.dateDeleted) {
        response.data.dateDeleted = new Date(
          response.data.dateDeleted
        ).toISOString();
      }
      return response.data;
    })
    .catch(error => {
      if (error.response && error.response.status === 404) {
        return Promise.reject('Project not found');
      }
      return Promise.reject(
        error.response ? error.response.data : 'An error occurred'
      );
    });
};

const projectsService = {
  getAllByUser,
  getAllProjects,
  addProject,
  editProject,
  deleteProject,
  getProjectByID
};
export default projectsService;
